(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/ticket-with-podium.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/ticket-with-podium.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const tickets = svs.tickets;
const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const ImageMemo = tickets.next.components.ImageMemo;
const TicketWithPodiumShadow = tickets.next.components.TicketWithPodiumShadow;
const useTicketWithPodiumShadow = tickets.next.components.ticketWithPodiumShadow.useTicketWithPodiumShadow;
const stageStyle = {
  '--panel-base-width': '78%',
  '--panel-grow-x': '30%',
  '--panel-overhang-x': '10%',
  '--panel-max-width': 'calc(100% + (var(--panel-overhang-x) * 2))',
  '--platform-overhang': '8%',
  '--platform-bleed-bottom': '3%',
  '--anchor-x': '50%',
  '--platform-width': 'calc(100% + (var(--platform-overhang) * 2))',
  '--panel-drop': 'calc(var(--platform-width) * 0.05)',
  '--panel-bottom': 'calc((var(--platform-width) / (819 / 147)) - var(--panel-drop))',
  '--panel-reserve-px': '0px',
  '--panel-lift-px': '0px',
  position: 'relative',
  width: '100%',
  paddingTop: 'var(--panel-reserve-px)',
  overflow: 'visible',
  margin: '0 auto'
};
const panelStyle = {
  position: 'absolute',
  left: 'var(--anchor-x)',
  top: 0,
  bottom: 'var(--panel-bottom)',
  transform: 'translate(-50%, calc(var(--panel-lift-px) * -1))',
  width: 'min(calc(var(--panel-base-width) + var(--panel-grow-x)), var(--panel-max-width))',
  zIndex: 3,
  transformOrigin: '50% 100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'visible'
};


const platformStyle = {
  position: 'absolute',
  left: '50%',
  bottom: 'calc(var(--platform-bleed-bottom) * -1)',
  width: 'var(--platform-width)',
  zIndex: 1
};
const panelLinkStyle = {
  position: 'relative',
  zIndex: 5,
  textDecoration: 'none',
  color: 'inherit',
  display: 'block',
  cursor: 'pointer',
  height: '100%',
  maxWidth: '100%'
};
const getImageSource = function () {
  let image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return image.src || image.url || image.noscriptUrl || image.originalUrl || '';
};
const getImageAspectRatio = function () {
  let image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const width = Number(image === null || image === void 0 ? void 0 : image.width);
  const height = Number(image === null || image === void 0 ? void 0 : image.height);
  if (Number.isFinite(width) && Number.isFinite(height) && height > 0) {
    return width / height;
  }
  return 1;
};
const TicketWithPodium = _ref => {
  let ticketType = _ref.ticketType,
    onClick = _ref.onClick,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? "".concat(svs.core.config.data.svsconfig.cdn, "/images/tickets/next-gen/skin.webp") : _ref$image,
    _ref$platformTranslat = _ref.platformTranslateY,
    platformTranslateY = _ref$platformTranslat === void 0 ? '22%' : _ref$platformTranslat;
  const platformOverhang = '8%';
  const panelGrowX = '30%';
  const stageAspectRatio = '1 / 1';
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isImageLoaded = _useState2[0],
    setIsImageLoaded = _useState2[1];
  const hasResolvedImageLoadRef = useRef(false);
  const previousImageSourceRef = useRef(null);
  const imageData = typeof image === 'string' ? {
    src: image
  } : image;
  const imageSource = getImageSource(imageData);
  const imageAspectRatio = getImageAspectRatio(imageData);
  const resolvedObjectPosition = 'center bottom';
  const _useTicketWithPodiumS = useTicketWithPodiumShadow(),
    stageRef = _useTicketWithPodiumS.stageRef,
    panelRef = _useTicketWithPodiumS.panelRef,
    _useTicketWithPodiumS2 = _useTicketWithPodiumS.configuredLiftPx,
    configuredLiftPx = _useTicketWithPodiumS2 === void 0 ? 0 : _useTicketWithPodiumS2,
    _useTicketWithPodiumS3 = _useTicketWithPodiumS.reservedLiftPx,
    reservedLiftPx = _useTicketWithPodiumS3 === void 0 ? 0 : _useTicketWithPodiumS3;
  const hasImagePlaceholder = true;
  const showImagePlaceholder = !isImageLoaded;
  const handleImageLoad = useCallback(() => {
    if (hasResolvedImageLoadRef.current) {
      return;
    }
    hasResolvedImageLoadRef.current = true;
    setIsImageLoaded(true);
  }, []);
  const floatingContent = React.createElement(ImageMemo, {
    cssSelectors: isImageLoaded ? 'ticket-with-podium-image' : 'ticket-with-podium-image ticket-with-podium-image--loading',
    fitWrapper: false,
    image: _objectSpread(_objectSpread({}, imageData), {}, {
      altText: (imageData === null || imageData === void 0 ? void 0 : imageData.altText) || ticketType
    }),
    onLoadCallback: handleImageLoad
  });
  useEffect(() => {
    if (previousImageSourceRef.current === null) {
      previousImageSourceRef.current = imageSource;
      return;
    }
    if (previousImageSourceRef.current !== imageSource) {
      previousImageSourceRef.current = imageSource;
      hasResolvedImageLoadRef.current = false;
      setIsImageLoaded(false);
    }
  }, [imageSource]);
  return React.createElement("div", {
    className: "ticket-with-podium ticket-with-podium--interactive",
    "data-ticket-type": ticketType || '',
    ref: stageRef,
    style: _objectSpread(_objectSpread({}, stageStyle), {}, {
      aspectRatio: stageAspectRatio,
      '--panel-grow-x': panelGrowX,
      '--platform-overhang': platformOverhang,
      '--panel-reserve-px': "".concat(reservedLiftPx, "px"),
      '--panel-lift-px': '0px',
      '--ticket-with-podium-object-position': resolvedObjectPosition,
      marginTop: "".concat(configuredLiftPx, "px")
    })
  }, React.createElement("div", {
    className: "ticket-with-podium-panel",
    ref: panelRef,
    style: panelStyle
  }, React.createElement("a", {
    "aria-label": ticketType || 'Välj lott',
    className: "qa-ticket-with-podium-hitbox",
    href: "#",
    onClick: onClick,
    style: _objectSpread(_objectSpread({}, panelLinkStyle), {}, {
      aspectRatio: imageAspectRatio
    })
  }, hasImagePlaceholder && React.createElement("div", {
    "aria-hidden": "true",
    className: showImagePlaceholder ? 'ticket-with-podium-image-placeholder ticket-with-podium-image-placeholder--visible' : 'ticket-with-podium-image-placeholder',
    style: {
      width: '100%',
      height: '100%'
    }
  }), floatingContent)), React.createElement(TicketWithPodiumShadow, {
    aspectRatio: imageAspectRatio,
    centered: true,
    opacity: 0.7,
    overrridStyle: platformStyle,
    translateY: platformTranslateY
  }));
};
setGlobal('svs.tickets.next.components.TicketWithPodium', TicketWithPodium);

 })(window);